import React from 'react'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'

export default ({ onRetryClick }) => (
	<React.Fragment>
		<Typography variant="body1" gutterBottom>
			Det gick inte att hämta data om stompunkten.
		</Typography>
		<Button onClick={onRetryClick} variant="contained" color="secondary">
			Försök igen
		</Button>
	</React.Fragment>
)


// WEBPACK FOOTER //
// ./src/components/Stompunkt/StompunktError.js